import { render, staticRenderFns } from "./SelecaoMultiplaTpl.vue?vue&type=template&id=e51488e6&"
import script from "./SelecaoMultiplaTpl.vue?vue&type=script&lang=js&"
export * from "./SelecaoMultiplaTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports